<div
  class="pie-chart-container"
  bshResizeObserver
  (resized)="observeResize($event)">
  @if (_config.title) {
    <h4 class="chart-title">{{ _config.title }}</h4>
  }
  <svg [attr.width]="width" [attr.height]="height">
    <g [attr.transform]="'translate(' + width / 2 + ',' + height / 2 + ')'">
      <!-- Color scale -->
      @for (arc of arcs; track arc.data.label) {
        <path
          [attr.d]="arcPath(arc)"
          [attr.fill]="arcFill(arc)"
          stroke="#fff"
          stroke-width="2"></path>
        @if (arc.endAngle - arc.startAngle > 0.2) {
          <text
            [attr.x]="labelPos(arc).x"
            [attr.y]="labelPos(arc).y"
            text-anchor="middle"
            alignment-baseline="middle"
            font-size="13"
            fill="#333">
            {{ arc.data.label }} ({{ arc.data.value }})
          </text>
        }
      }
    </g>
    <g
      bshLegend
      [subgroups]="subgroups"
      [colors]="_config.colors"
      [visible]="_config.showLegend"
      [legendX]="width - legendWidth"
      [legendY]="20"
      [spacing]="22"
      [legendWidth]="legendWidth"></g>
  </svg>
</div>
